<template>
  <footer class="app-footer">
    <!-- 顶部分割线 -->
    <div class="divider"></div>

    <div class="footer-inner">
      <!-- 左侧 logo -->
      <div class="left">
        <img class="logo" src="@/assets/img/u7.png" alt="LETUS" />
      </div>

      <!-- 中间信息 -->
      <div class="center">
        <p class="underline">LETUS QINGDAO ENTERPRISE</p>
        <p class="spacer"></p>
        <p>
          Email: letus_trading@163.com<br />
          <span class="indent">letus_industrial@163.com</span>
        </p>
        <p>Cell/WhatsApp/WeChat: +86 186 3545 5313</p>
        <p>
          Add: No.16 huize, yinzhu, huangdao zone,<br />
          Qingdao city, China
        </p>
      </div>

      <!-- 右侧二维码 -->
      <div class="right">
        <div class="qr-item">
          <img src="@/assets/img/u15.png" alt="WhatsApp" />
          <span>WhatsApp</span>
        </div>
        <div class="qr-item">
          <img src="@/assets/img/u16.png" alt="WeChat" />
          <span>WeChat</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
// 纯展示组件，无逻辑
export default { name: 'Footer' };
</script>

<style scoped>
.app-footer {
  background: #fff;
  color: #222;
  font: 14px/1 'Helvetica Neue', Arial, sans-serif;
}

.divider {
  height: 1px;
  background: #e0e0e0;
  margin: 0 40px;
}

.footer-inner {
  display: flex;
  align-items: flex-start; /* 统一顶部对齐 */
  justify-content: center;
  gap: 60px;
  padding: 20px 40px;
}

.logo {
  width: 60px;
  height: auto;
}

.underline {
  margin: 4px 0 0;
  font-size: 16px;
  letter-spacing: 1px;
  color: #025aa1;
  font-weight: 700;
}

.spacer {
  height: 0.8em;
}

.indent {
  margin-left: 3.1em;
}

.center {
  line-height: 1.8;
}

.center p {
  margin: 0;
}

.right {
  display: flex;
  gap: 20px;
}

.qr-item {
  text-align: center;
  font-size: 12px;
}

.qr-item img {
  width: 80px;
  height: 80px;
  display: block;
  margin: 0 auto 6px;
  border: 2px solid #fff;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .footer-inner {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .left,
  .center,
  .right {
    width: 100%;
    text-align: center;
  }

  .indent {
    margin-left: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue